module.exports = __webpack_public_path__ + "static/media/not-found.ce06603f.jpg";